document.addEventListener("DOMContentLoaded", function () {
(function () { 

  var back_url = document.getElementById("flipkart-red-link").getAttribute("href");
    if (document.referrer.indexOf('/checkouts') !== -1 ||
        document.referrer.indexOf('/thank_you') !== -1 ||
        document.referrer.indexOf('/orders') !== -1) return;

    var back_button_enabled = false;
    var g_popupShown = false;
    var domain_has_valid_cert = true;
    var sawpp = false;
    var dpush = false;
    var dsopush = false;

    function pushInitState() {
      if (!back_button_enabled) {
        history.pushState({ init: true }, document.title, "");
      }
    }

    function reArmOnClick() {
      pushInitState();
      document.body.removeEventListener("click", reArmOnClick);
    }

    pushInitState();

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        document.body.addEventListener("click", reArmOnClick);
      });
    } else {
      document.body.addEventListener("click", reArmOnClick);
    }

    window.addEventListener("pageshow", function (e) {
      if (e.persisted) {
        window.onbeforeunload = function () {};
        if (back_url !== "" && !back_button_enabled) {
          window.location.replace(back_url);
        }
      }
    });

    window.addEventListener("popstate", function (e) {
      window.onbeforeunload = function () {};

      if (
        back_url !== "" &&
        !back_button_enabled &&
        window.location.href.indexOf("dbbtn_") === -1
      ) {
        if (back_url !== "" && dpush && back_url.indexOf("dpush_") === -1) {
          var sep = back_url.indexOf("?") !== -1 ? "&" : "?";
          back_url += sep + "dpush_=1";
        }
        window.location.replace(back_url);
      } else if (!sawpp && !dpush) {
        if (domain_has_valid_cert && location.protocol === "http:") {
          window.location.replace(get_same_location_with_push());
        } else if (location.protocol === "https:") {
          window.show_pushwru_show && window.show_pushwru_show();
        }
      }
    });

    window.get_same_location_with_push = function () {
      var s = location.href.replace("http", "https").replace("#init", "");
      var o = s.indexOf("?") === -1 ? "?" : "&";
      return s += o + "showing_push_=1";
    };

    window.move_next = function (a, obj, openSelf) {
      openSelf = openSelf || false;

      if (a && a.preventDefault) a.preventDefault();
      if (a && a.stopPropagation) a.stopPropagation();

      if (!Object.keys) {
        Object.keys = function (obj) {
          var keys = [];
          for (var i in obj) {
            if (obj.hasOwnProperty(i)) keys.push(i);
          }
          return keys;
        };
      }

      var redirect_url = back_url;
      if (obj !== undefined) {
        redirect_url += "&" + Object.keys(obj).map(function (k) {
          return k + "=" + encodeURIComponent(obj[k]);
        }).join("&");
      }

      if (back_url === "" && sawpp !== true && dpush !== true) {
        if (domain_has_valid_cert === true && location.protocol === "http:") {
          back_url = window.get_same_location_with_push();
        } else if (location.protocol === "https:") {
          setTimeout(function () {
            window.show_pushwru_show && window.show_pushwru_show();
          }, 1);
        }
      }

      if (back_url !== "") {
        window.location.replace(back_url);
      }

      if (openSelf || back_button_enabled) {
        window.open(redirect_url, "_self");
        if (back_url !== "") window.location.replace(back_url);
      } else {
        window.open(redirect_url);
        if (back_url !== "") window.location.replace(back_url);
      }
    };

    (function () {
      var ua = navigator.userAgent;
      var isIOS = /iphone|ipad|ipod/i.test(ua);
      var isSafari = /safari/i.test(ua) && !/chrome/i.test(ua);

      if (isIOS || isSafari) {
        window.addEventListener("pageshow", function (evt) {
          if (evt.persisted || (window.performance && window.performance.navigation.type === 2)) {
            window.onbeforeunload = function () {};
            if (back_url !== "") {
              window.location.replace(back_url);
            }
          }
        });

        history.pushState({ init: true }, document.title, "");
        history.pushState({ init: true }, document.title, "");
      }
    })();

})();

});
